<div class="header p-0">
    <div class="logo-box state-name" [style]="!showSelectState() ? 'display: block' : 'visibility: hidden'">
        <h2>
            {{ stateDetails()?.name || '' }} Secretary of State
        </h2>
        <p>
            <span class="material-symbols-outlined">
                location_on
            </span> {{ formattedAddress() }}
            <br>
            <span class="material-symbols-outlined">
                phone
            </span> {{ formattedPhone() }}
        </p>
    </div>
    <div class="background-img state-bg p-0">
        <img
            [src]=" showSelectState() ? 'assets/imgs/states/cap.png' : stateImageUrl()"
            [alt]="stateCode() + ' state image'" width="100%">
    </div>
</div>

